/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/StarClubMenu',[
		'lodash',
		'pixi',
		'absolute',
		'absolute/stringmanager',
		'absolute/screenmetrics',
		'Solitaire/MvvmStructure/Service/SolitaireStarClubService',
		'MenuUI/Menu',
		'MenuUI/StarClubCollectionTile',
		'MenuUI/MultiPageMenu',
		'MenuUI/ColorConstants',
		'MenuUI/DealWarningModal',
		'Managers/StatManager',
		'MenuUI/BadgeEarnedDialog',
		'util/SettingsManager',
		'MenuUI/ControlFocusManager',
		'MenuUI/SideBar',
		'audiosprites',
		'Managers/ScaleManager',
		'Managers/ScrollManager'
	],
	function (_, PIXI, Absolute, _s, ScreenMetrics, SolitaireStarClubService, Menu, StarClubCollectionTile,
	          MultiPageMenu, ColorContstants, DealWarningModal, StatManager, FUEDialog, SettingsManager,
	          ControlFocusManager, SideBar, AudioData, ScaleManager, ScrollManager) {
		"use strict";

		var StarClubMenu = function (ui, game) {
			this.initStarClubMenu(ui, game);
		};

		StarClubMenu.prototype = Object.create(Absolute.Screen.prototype);
		StarClubMenu.prototype.constructor = StarClubMenu;

		StarClubMenu.prototype.initStarClubMenu = function (ui, game) {
			Absolute.Screen.call(this);
			this.ui = ui;
			this.game = game;

			this.dataInitialized = false;
			this.artInitialized = false;
			this.firstRun = true;
			this.settingsManager = SettingsManager;
			this.paginatedMenu = null;
			this.currentPageIndex = 0;
			this.sectionSelected = false;

			var background = PIXI.Sprite.fromFrame('win10_MS_bg.png');
			this.background.addChild(background);

			this.collectionGroupContainer = new PIXI.DisplayObjectContainer();
			this.addChild(this.collectionGroupContainer);

			this.controlFocusManager = new ControlFocusManager();

			this.scrollEventHandler = this.doScroll.bind(this);
			this.clickHandler = this.handleGameInput.bind(this);
			window.addEventListener('click', this.clickHandler);
			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
		};

		StarClubMenu.prototype.handleResize = function () {
            setTimeout(function () {
                if (!this.scrollable) return;
                this.scrollTo(this.scrollable.y);
                this.container.y = (this.game.menuBar.menuButton.y + this.game.menuBar.menuButton.height)
                    * (this.container.width * this.container.children[0].pageGenerator.cardScale / ScaleManager.width) * (ScaleManager.height / Absolute.Coords.y(985));
                this.updatePagesPositions();
                this.scrollable.height = (this.currentWidth / this.container.width) * (Absolute.Coords.y(985) / ScaleManager.height)
                    * (ScaleManager.width / Absolute.Coords.x(1840)) * this.currentHeight;
                this.scrollable.width = this.currentWidth;
                this.scrollableFakeHeight = this.scrollable.height + Absolute.Coords.x(150);
                if ((this.scrollable.y < 0) && ((this.scrollableFakeHeight + this.scrollable.y) < Absolute.Coords.y(1080))) {
                    this.scrollable.y = Absolute.Coords.y(1080) - this.scrollableFakeHeight;
                }
                this.updateSidebar();
            }.bind(this), 250);
		};

		StarClubMenu.prototype.updatePagesPositions = function () {
			var prevChild, scale = (this.container.width / this.currentWidth),
				xPos = Absolute.Coords.x(50), yGap = Absolute.Coords.y(70) * scale,
				startY = Absolute.Coords.y(90) * scale;
			this.currentHeight = Absolute.Coords.y(140);
			this.container.children.forEach(function (c) {
				c.x = xPos;
				c.y = prevChild ? prevChild.y + prevChild.height + yGap : startY;
				this.currentHeight += c.height + (prevChild ? yGap : 0);
				prevChild = c;
			}.bind(this));
		};

		StarClubMenu.prototype.buildTileTextures = function () {

			function buildTileTexture(bgColor, iconId, textureId) {
				var icon = PIXI.Sprite.fromFrame(iconId),
					graphics = new PIXI.Graphics(),
					container = new PIXI.DisplayObjectContainer();

				graphics.beginFill(bgColor);
				graphics.drawRect(0, 0, Absolute.Coords.x(328), Absolute.Coords.y(352));
				graphics.endFill();

				container.addChild(graphics);

				icon.x = (container.width - icon.width) / 2;
				icon.y = (container.height - icon.height) / 2;

				container.addChild(icon);

				PIXI.Texture.addTextureToCache(container.generateTexture(), textureId);
			}

			buildTileTexture(ColorContstants.Klondike, "game_mode_tile_icons/icon_tile_klondike.png", "dailychallenge/SC_tile_klondike.png");
			buildTileTexture(ColorContstants.Spider, "game_mode_tile_icons/icon_tile_spider.png", "dailychallenge/SC_tile_spider.png");
			buildTileTexture(ColorContstants.FreeCell, "game_mode_tile_icons/icon_tile_freecell.png", "dailychallenge/SC_tile_freecell.png");
			buildTileTexture(ColorContstants.Pyramid, "game_mode_tile_icons/icon_tile_pyramid.png", "dailychallenge/SC_tile_pyramid.png");
			buildTileTexture(ColorContstants.TriPeaks, "game_mode_tile_icons/icon_tile_tripeaks.png", "dailychallenge/SC_tile_tripeaks.png");
		};

		StarClubMenu.prototype.onCollectionsLoaded = function () {

			SolitaireStarClubService.UpdateGlobalStarClubStats();

			while (this.collectionGroupContainer.children.length > 0) {
				this.collectionGroupContainer.removeChildAt(0);
			}
			this.collectionGroupMenus = [];

			this.controlsGroupMap = {};

			var pages = [];

			SolitaireStarClubService.CollectionGroups.reverse();

			_.forEach(SolitaireStarClubService.CollectionGroups, function (collectionGroup) {

				var collectionTiles = [];

				_.forEach(collectionGroup.Collections, function (collection) {

					var tileData = {
						userData: collection,
						image: collection.icon,
						icon: '',
						label: '',
						action: null,
						letterStyle: {
							font: Absolute.ScreenMetrics.getResScale() * 33 + 'px Arial',
							fontFamily: 'segoe',
							fill: '#ffffff',
							tint: 0xffffff,
							align: 'left'
						},
						iconPosition: {
							x: 0,
							y: 0
						},
						labelPosition: {
							x: Absolute.Coords.x(88),
							y: 0
						},
						labelPadding: Absolute.Coords.y(15),
						labelOffset: Absolute.Coords.y(22),
						dropShadow: true,
						hoverBox: true
					};

					tileData.action = this.onCollectionSelected.bind(this);

					var collectionTile = new StarClubCollectionTile(tileData, collection, this);
					collectionTiles.push(collectionTile);
					this.controlsGroupMap[collectionGroup.Name] = this.controlsGroupMap[collectionGroup.Name] || [];
					this.controlsGroupMap[collectionGroup.Name].push(collectionTile);
				}, this);
				var menuConfig = _.extend({'tiles': collectionTiles}, ScaleManager.scaleParams['SC-CollectionGroupsMenuConfigs'][collectionGroup.Name]);
				var collectionGroupMenu = new Menu(_.extend(menuConfig, ScaleManager.scaleParams['MenuConfigs']['SCMenuConfigs']));

				this.collectionGroupMenus.push(collectionGroupMenu);
				collectionGroupMenu.onShow();
				// page.displayName = _s("menu." + collectionGroup.Name);
				pages.push(collectionGroupMenu);

			}, this);

			this.currentWidth = Absolute.Coords.x(1840);
			this.scrollable = new PIXI.DisplayObjectContainer();
			this.container = new PIXI.DisplayObjectContainer();

			pages.forEach(function (p) {
				this.container.addChild(p)
			}.bind(this));
			this.updatePagesPositions();

			this.scrollable.addChild(this.container);
			this.addChild(this.scrollable);
			this.scrollable.width = this.currentWidth;
			this.handleResize();
		};

		StarClubMenu.prototype.initTouchInterface = function () {
			// Dragging and panning
			this.lastDeltaY = 0;
			this.startY = 0;
			var hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
			this.touchContainer = new PIXI.DisplayObjectContainer();
			this.touchContainer.interactive = true;
			this.touchContainer.hitArea = hitArea;
			this.touchContainer.addChild(this.scrollable);
			this.touchContainer.mousedown = this.touchContainer.touchstart = this.handleDragStart.bind(this);
			this.touchContainer.mousemove = this.touchContainer.touchmove = this.handleDrag.bind(this);
			this.touchContainer.mouseupoutside = this.touchContainer.mouseup = this.touchContainer.touchend = this.touchContainer.touchendoutside = this.handleDragEnd.bind(this);
			this.addChild(this.touchContainer);

		};

		StarClubMenu.prototype.handleDragStart = function (data) {
			this.dragging = true;
			this.lastDeltaY = 0;
			this.startY = data.getLocalPosition(this.parent).y;
			this.enableButtons(false);
		};

		StarClubMenu.prototype.handleDrag = function (data) {

			if (!this.dragging) {
				return;
			}

			var pos = data.getLocalPosition(this.parent),
				delta = pos.y - this.startY;
			this.scrollTo(this.scrollable.y + ((delta - this.lastDeltaY)));

			this.lastDeltaY = delta;
		};

		StarClubMenu.prototype.handleDragEnd = function (data) {

			if (!this.dragging) {
				return;
			}
			this.dragging = false;
		};

		StarClubMenu.prototype.enableButtons = function (enable) {

			var i, l;

			for (i = 0, l = this.scrollable.children.length; i < l; i++) {
				this.scrollable.children[i].interactive = enable;
			}

		};

		StarClubMenu.prototype.loadArtAssets = function (onSuccess, onError) {
			var levelLoader = new Absolute.Loader(),
				atlases = [{name: 'dc_menu'}];

			var soundsToLoad = [];
			_.forEach(AudioData, function (clipInfo) {
				if (clipInfo.loadgroup == "challenge") {
					if (!Absolute.AudioManager.soundLoaded(clipInfo.id)) {
						clipInfo.lazyload = false;
						soundsToLoad.push(clipInfo);
					}
				}
			});

			levelLoader.loadSound(soundsToLoad, function (percentComplete) {
				},
				function () {

				});

			levelLoader.loadAtlases(atlases,
				function (percentComplete) {
					// todo show card spinner
					Absolute.Debug.log('loading dc menu assets ', percentComplete);
				}.bind(this),
				onSuccess,
				onError);
		};

		StarClubMenu.prototype.onShow = function (isPortrait) {
			Absolute.Screen.prototype.onShow.call(this);
			if (this.scrollable) this.scrollable.y = 0;
			this.ui.showLoadingScreen();
			if (!this.dataInitialized) {
				SolitaireStarClubService.Initialize(
					function () {
						this.dataInitialized = true;
						this.onCollectionsLoaded();

						if (!this.artInitialized) {
							this.loadArtAssets(
								function () {
									this.artInitialized = true;
									this.completeInit();
								}.bind(this),
								this.showError.bind(this)
							);
						} else {
							this.completeInit();
						}
					}.bind(this),
					this.showLoadError.bind(this)
				);
			} else {
				if (!this.artInitialized) {
					this.loadArtAssets(
						function () {
							this.artInitialized = true;
							this.completeInit();
						}.bind(this),
						this.showError.bind(this)
					);
				} else {
					this.completeInit();
				}
			}
			if (!this.sidebar) this.initSidebar();
			this.addChild(this.sidebar);
			this.scrollTo(0);
			this.handleResize();
			ScrollManager.add(this, this.doScroll, this);
            this.background.scale.set(
				1 / Math.min(ScaleManager.scaleFactorX, 1), 1 / Math.min(1, ScaleManager.scaleFactorY)
			);
		};

		StarClubMenu.prototype.completeInit = function () {
			this.initControls();
			this.initTouchInterface();
			this.updateTheme();
			var label = Absolute.StringManager('titles.starClub');
			this.game.menuBar.onShow(true, true, this.collectionGroupMenus && this.collectionGroupMenus.length > 0, label);
			this.ui.refreshBackground = true;

			if (this.firstRun) {
				this.buildTileTextures();
				if (this.settingsManager.getSetting('general', 'showSCFUE')) {
					this.buildFUE();
					this.settingsManager.setSetting('general', 'showSCFUE', false);
				}
				this.firstRun = false;
			} else {
				this.checkForUnlockableCollections(this.currentPageIndex);
			}

			if (this.collectionGroupMenus) {
				for (var i = 0; i < this.collectionGroupMenus.length; i++) {
					this.collectionGroupMenus[i].onShow();
				}
			}
			this.addChild(this.game.menuBar);
			this.game.menuBar.onShow(true, true, false, label);

			this.game.menuBar.starCountDisplay.onShow(SolitaireStarClubService.GetStarClubGlobalStats().totalStarsEarned, true);
			this.game.menuBar.starCountDisplay.visible = true;

			this.ui.hideLoadingScreen();

			this.handleResize();
			this.addChild(this.sidebar);
		};

		StarClubMenu.prototype.initControls = function () {
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[0], false, 'LeftButtons');
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[1], false, 'LeftButtons');
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[2], false, 'RightButtons');
			if (this.game.menuBar.fullScreenEnabled) {
				this.controlFocusManager.addControl(this.game.menuBar.controlGroup[3], false, 'RightButtons');
			}
			for (var key in this.controlsGroupMap) {
				if (this.controlsGroupMap.hasOwnProperty(key)) {
					for (var i = 0; i < this.controlsGroupMap[key].length; i++) {
						this.controlFocusManager.addControl(this.controlsGroupMap[key][i], false, key);
					}
				}
			}
		};

		StarClubMenu.prototype.initSidebar = function () {
			this.sidebar = new SideBar({
				availableHeight: 200, partialHeight: 100,
				onScrollUpdate: function (p) {
				}.bind(this)
			});
			this.addChild(this.sidebar);
			this.sidebar.position.set(Absolute.Coords.x(1900), Absolute.Coords.y(67));
			this.updateSidebar();

		};

		StarClubMenu.prototype.updateSidebar = function () {
			if (!this.sidebar || !this.scrollable) return;
            var height = this.game.menuBar.menuBarHeight;

            var resizeScale = 1;
            if (Absolute.Platform.isMobile()) {
                height *= 0.7;
                if (Absolute.ScreenMetrics.isPortrait()) {
                    resizeScale = 0.5;
                }
            }

			var screenScaleX = ScaleManager.width / Absolute.Coords.x(1920),
				screenScaleY = ScaleManager.height / Absolute.Coords.y(1080);
			this.sidebar.scale.set(1, 1);
            this.sidebar.width = this.sidebar.width / screenScaleX * resizeScale;
			this.sidebar.height = this.sidebar.height / screenScaleY;
			this.sidebar.y = height / screenScaleY;
			this.sidebar.x = Absolute.Coords.x(1900) - (this.sidebar.width - (this.sidebar.width * screenScaleX));
			var availableHeight, partialHeight, posY;
			availableHeight = this.scrollableFakeHeight;
			partialHeight = Absolute.Coords.x(1080);
			posY = availableHeight - Absolute.Coords.y(1080);
			this.sidebar.resetDimensions(availableHeight, partialHeight, function (p) {
				var y = -Math.abs(posY) * p / 100;
				this.scrollable.y = y;
				if (this.scrollable.y > 0) this.scrollable.y = 0;
				if (Math.abs(this.scrollable.y) > posY) {
					this.scrollable.y = -posY;
				}
			}.bind(this), (ScaleManager.height - height));
			this.sidebar.visible = (partialHeight < availableHeight);
			this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};

		StarClubMenu.prototype.updateTheme = function () {
			var gamesCollection = SolitaireStarClubService.CollectionGroups[0],
				mixedCollection = SolitaireStarClubService.CollectionGroups[1],
				settingsTheme = SettingsManager.getSetting('theme', 'selected'),
				thiz = this;
			gamesCollection.Collections
				.forEach(function (c) {
					thiz.setChallengesThemes(c, settingsTheme);
				});
			mixedCollection.Collections
				.filter(function (c) {
					return c.Name !== 'Classic' && c.Theme === 'classic'
				})
				.forEach(function (c) {
					thiz.setChallengesThemes(c, settingsTheme);
				});
		};

		StarClubMenu.prototype.setChallengesThemes = function (challengeConfig, theme) {
			challengeConfig.Packs.forEach(function (p) {
				p.Challenges.forEach(function (ch) {
					ch.theme = theme;
				});
			})
		};


		StarClubMenu.prototype.onHide = function () {
			Absolute.Screen.prototype.onHide.call(this);
			ScrollManager.remove(this);
			SolitaireStarClubService.UpdateGlobalStarClubStats();
			this.controlFocusManager.removeAllControls();
			this.sectionSelected = false;
			this.currentPageIndex = 0;
		};

		StarClubMenu.prototype.onCollectionSelected = function (collection) {
			SolitaireStarClubService.currentCollection = collection;
			this.game.navStarClubCollection(collection);
		};

		StarClubMenu.prototype.showLockedWarning = function (amountNeeded, type) {
			this.ui.showWarning(_s("dialogs.needMoreStarsTitle"), _s("dialogs.needMoreStarsContent", [amountNeeded, type]));
		};

		StarClubMenu.prototype.showLoadError = function () {

			this.ui.showWarning(_s("dialogs.manifestWarningHeadline"), _s("dialogs.manifestWarningContent"),
				function () {
					this.ui.hideLoadingScreen();
					this.game.navBack();
				}.bind(this)
			);
		};

		StarClubMenu.prototype.buildFUE = function () {
			ScrollManager.disableScroll();
			var fue1 = new FUEDialog(this.ui, this.game,
				{
					offsetX: Absolute.Coords.x(10),
					offsetY: Absolute.Coords.x(10),
					dialog: 'SC-FUE-1',
					width: Absolute.Coords.x(1300),
					closeHandler: function () {
						ScrollManager.enableScroll();
					}
				});

			fue1.open();
		};

		StarClubMenu.prototype.handleCommand = function (command, isMouseWheel) {
			if (isMouseWheel) return;
			this.selectSection(command, isMouseWheel);
			var current;
			switch (command) {
				case 'Right': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(1);
					if (!isMouseWheel) {
						current = this.controlFocusManager.getCurrentControl()
						this.scrollTo(-current._bounds.y + current.height * 2);
					}
					break;
				}
				case 'Left': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(-1);
					if (!isMouseWheel) {
						current = this.controlFocusManager.getCurrentControl();
						this.scrollTo(-current._bounds.y + current.height * 2);
					}
					break;
				}
				case 'Up': {
					if (this.controlFocusManager.getCurrentControl()) {
						if (this.controlFocusManager.focusNextControl(-1)) {
							this.startScrolling(-2);
						}
					} else {
						this.startScrolling(-2);
					}
					break;
				}
				case 'Down': {
					if (this.controlFocusManager.getCurrentControl()) {
						if (this.controlFocusManager.focusNextControl(1)) {
							this.startScrolling(2);
						}
					} else {
						this.startScrolling(2);
					}
					break;
				}
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
				case 'Unfocus':
					this.controlFocusManager.unfocusCurrentControl();
					break;
			}

		};

		StarClubMenu.prototype.handlePageChange = function (from, to) {
			switch (to) {
				case 0:
					this.controlFocusManager.setFocusGroup('LeftButtons');
					break;
				case 1:
					this.controlFocusManager.setFocusGroup('RightButtons');
					break;
				case 2:
					this.controlFocusManager.setFocusGroup('GamesCollection');
					this.currentPageIndex = to;
					this.checkForUnlockableCollections(0);
					break;
				case 3:
					this.controlFocusManager.setFocusGroup('MixedCollection');
					this.currentPageIndex = to;
					this.checkForUnlockableCollections(1);
					break;
			}
		};


		StarClubMenu.prototype.doScroll = function (e) {
			if (!this.scrollable) return;
			if (this.scrollableFakeHeight <= Absolute.Coords.y(1080)) {
				this.scrollable.y = 0;
				return;
			}
			var deltaY = 0;
			if (!e) e = window.event;
			if (e.wheelDelta) {
				deltaY = e.wheelDelta / 35;
			} else if (e.detail) {
				deltaY = -e.detail / 3;
			}
			this.scrollTo(this.scrollable.y + (deltaY * 100));
		};

		StarClubMenu.prototype.scrollTo = function (y, scroller) {
			if (!this.scrollable) return;
			if (this.scrollableFakeHeight <= Absolute.Coords.y(1080)) {
				this.scrollable.y = 0;
				return;
			}
			this.scrollable.y = y;
			if (this.scrollable.y > 0) this.scrollable.y = 0;
			var posY = this.scrollableFakeHeight - Absolute.Coords.y(1080);
			if (Math.abs(this.scrollable.y) > posY) {
				this.scrollable.y = -posY;
			}
			if (this.sidebar) this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};

		StarClubMenu.prototype.checkForUnlockableCollections = function (index) {
			if (!this.settingsManager.getSetting('general', 'showSCFUE2')) {
				return;
			}

			var fue2Open = false;
			_.each(this.collectionGroupMenus[index].config.tiles, function (collectionTile) {

				if (fue2Open) {
					return;
				}

				if (!collectionTile.collection.Unlocked &&
					StatManager.GetValue("SCGlobalStarsEarned") >= collectionTile.collection.PriceOfUnlocking) {
					ScrollManager.disableScroll();
					var fue2 = new FUEDialog(this.ui, this.game,
						{
							offsetX: Absolute.Coords.x(10),
							offsetY: Absolute.Coords.x(10),
							dialog: 'SC-FUE-2',
							width: Absolute.Coords.x(1300),
							closeHandler: function () {
								ScrollManager.enableScroll();
							}
						});
					this.settingsManager.setSetting('general', 'showSCFUE2', false);
					fue2.open();
					fue2Open = true;
					return;
				}

			}, this);
		};

		StarClubMenu.prototype.selectSection = function (command, isMouseWheel) {
			if (command === 'Tab' || command === 'ShiftTab') {
				this.controlFocusManager.focusCurrentControl();
				this.sectionSelected = true;
				if (command === 'Tab') {
					if (this.page === 3) {
						this.handlePageChange(this.page, 0);
						this.page = 0;
					} else {
						this.controlFocusManager.nextFocusGroup();
					}
				} else if (command === 'ShiftTab') {
					if (this.page === 0) {
						this.handlePageChange(this.page, 3);
						this.page = 3;
					} else {
						this.controlFocusManager.prevFocusGroup();
					}
				}
				switch (this.controlFocusManager.currentFocusGroup) {
					case 'LeftButtons':
						this.page = 0;
						break;
					case 'RightButtons':
						this.page = 1;
						break;
					case 'GamesCollection':
						this.page = 2;
						break;
					case 'MixedCollection':
						this.page = 3;
						break;
				}
				var current = this.controlFocusManager.getCurrentControl();
				if (!isMouseWheel) {
					this.scrollTo(-current._bounds.y + current.height * 2);
				}
			}
		};

		StarClubMenu.prototype.handleGameInput = function () {
			this.resetControlManager();
		};

		StarClubMenu.prototype.resetControlManager = function () {
			this.controlFocusManager.unfocusCurrentControl();
		};

		StarClubMenu.prototype.startScrolling = function (delta) {
			this.sidebar.updateByArrow(delta);
		};
		return StarClubMenu;


	});

